import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CalendarPage } from "@/features/content/calendar";

const search = z.object({
  view: z.enum(["month", "week", "agenda"]).optional(),
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  event: z.string().uuid().optional(), // calendar event to open (notification deep links)
});

export const Route = createFileRoute("/_app/content/")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Calendar · Malfak" }] }),
  component: Calendar,
});

function Calendar() {
  const { view, date, event } = Route.useSearch();
  return <CalendarPage view={view} date={date} eventId={event} />;
}
